import { Navigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../stores/store';
import { AppRoute } from '../../constants/route';
import { generateLocaleRoute } from '../../utils/uri/uri.utils';

const LocaleSupportedCheckRoute = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const {
    localizationsStore: { availableCountries },
  } = useStore();
  const { locale } = useParams();

  if (!availableCountries) return children;

  if (!locale || locale?.split('-').length !== 2) return children;

  const [newCountryAlias, newLangCode] = locale.split('-');

  const pathAllowed = !!availableCountries
    ?.find((ac) => ac.alias === newCountryAlias)
    ?.allowed_languages.includes(newLangCode);

  if (!pathAllowed) {
    // Redirect to not-found if 1st path part is not in allowed set of len-country pairs
    return (
      <Navigate
        to={generateLocaleRoute(AppRoute.NOT_FOUND)}
        replace
      />
    );
  }

  return children;
};

export default observer(LocaleSupportedCheckRoute);
